<template>
  <toggle-button-group :options="stopTypeOptions" @change="handleChange" />
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'OtpStopTypeFilter',
  components: {
    toggleButtonGroup,
  },
  props: {
    selectedType: {
      type: String,
      default: 'all',
    },
  },
  computed: {
    stopTypeOptions() {
      const types = [
        { label: this.$t('flexigo.otp.firstStopOnly'), value: 'first' },
        { label: this.$t('flexigo.otp.allStops'), value: 'all' },
        { label: this.$t('flexigo.otp.lastStopOnly'), value: 'last' },
      ];

      return types.map((type) => ({
        label: type.label,
        selected: type.value === this.selectedType,
      }));
    },
  },
  methods: {
    handleChange({ index }) {
      const types = ['first', 'all', 'last'];
      this.$emit('change', types[index]);
    },
  },
};
</script>

<style scoped>
/* Styles handled by toggleButtonGroup component */
</style>
